
  import { defineComponent } from 'vue';
  import DotsVerticalIcon from '@/ui/components/icon/DotsVerticalIcon.vue';
  import { Icon } from '@/ui/components/icon/Icon';

  interface DropdownActionMenuProps {
    disableExport: boolean;
    hideChartOnlyActions: boolean;
  }

  export default defineComponent<DropdownActionMenuProps>({
    components: {
      DotsVerticalIcon,
      Icon,
    },
    props: ['disableExport', 'hideChartOnlyActions'],
    emits: ['add-card-after', 'delete-card', 'export', 'print', 'view-in-full-screen'],
    setup() {
      return {};
    },
  });
